// icons
import { ReactComponent as SpinnerIcon } from '../../assets/icons/spinner.svg'

// styles
import styles from './spinner.module.scss'

type SpinnerProps = {
	readonly className?: string
}

const Spinner = ({ className }: SpinnerProps): JSX.Element => {
	return (
		<div className={[styles.spinner, className].join(' ').trim()}>
			<SpinnerIcon />
		</div>
	)
}

export default Spinner
